module.exports = __webpack_public_path__ + "templates.dialog.product.quick_cart-6e1cf3b9.html";